import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeAttendance } from '@/components/employee/attendance';

const attendanceSearchSchema = z.object({
  startDate: z.string().optional(), // YYYY-MM-DD
  endDate: z.string().optional(), // YYYY-MM-DD
});

export const Route = createFileRoute('/(app)/employee/attendance/')({
  component: EmployeeAttendanceRoute,
  validateSearch: attendanceSearchSchema,
});

function EmployeeAttendanceRoute() {
  return (
    <EmployeeAttendance 
      showBackButton={false}
    />
  );
}
